module.exports = __webpack_public_path__ + "img/file_share.dfe44d34.svg";